import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";
import { logger } from "../lib/logger";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try { localStorage.removeItem("omr_guest"); } catch (e) { logger.warn("storage unavailable", e); }
    const fallback = setTimeout(() => setLoading(false), 8000);
    api.get("/auth/me", { timeout: 8000 })
      .then((res) => setUser(res.data))
      .catch((err) => { if (err.response?.status !== 401) logger.warn("session check failed", err); })
      .finally(() => { clearTimeout(fallback); setLoading(false); });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    api.post("/auth/logout").catch((e) => logger.warn("logout request failed", e));
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, isAdmin: user?.role === "admin" }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
